export default __webpack_public_path__ + "static/media/nike_stimuli_es_phone.f4b24bf2.mp4";